export default __webpack_public_path__ + "static/media/lager_822_info_1.0392731a.jpg";